
export interface GetBankAccountListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetBankAccountListPagingAndFilterResponseData
}

export interface GetBankAccountListPagingAndFilterResponseData {
    items: GetBankAccountListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetBankAccountListPagingAndFilterResponseItem {
    bankAccountId: string
    companyId: string
    name: string
    bankId: string
    openingBalance: number
    iban: string
    accountNo: string
    currencyTypeId: string
    accountingCode: string
    branchCode: string
    openingBalanceDate: string
    isCustomActive: boolean
    bankName: string
    currencyTypeName: string
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export const initialGetBankAccountListPagingAndFilterResponseData: GetBankAccountListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}